import React from "react";
import { useNavigate } from "react-router-dom";
import "./NotFoundPage.css";

// Catch-all for any authenticated URL that doesn't match a real route (a typo,
// a stale bookmark, a link to a page not built yet). Without this, App.js's
// inner <Routes> renders nothing for an unmatched path while the sidebar
// (LayoutShell) still renders around it - a blank content area with no
// explanation. Deliberately offers only "Go Back", not a link to "/" or any
// other page - this is a dead end, not a place to keep navigating from.
export const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found-page">
      <div className="not-found-page__card">
        <p className="not-found-page__eyebrow">Page not found</p>
        <h1 className="not-found-page__title">This page isn't ready yet</h1>
        <p className="not-found-page__body">
          There's nothing here right now - the page you're looking for
          doesn't exist or is still being built.
        </p>
        <button
          type="button"
          className="not-found-page__button"
          onClick={() => navigate(-1)}
        >
          Go Back
        </button>
      </div>
    </div>
  );
};

export default NotFoundPage;
